import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket/store'
import { type IResponseCallResumeConfirmed } from 'entities/Call/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'

// Backend pusher event: Twilio executed the resume TwiML (the unhold webhook
// fired), i.e. the call is really off hold — as opposed to just the /unhold
// HTTP 200 which is optimistic. We clear the on-hold state idempotently here;
// the reused-resume path already does it on the 200, so this is a confirmation.
export const useEventCallResumeConfirmed = () => {
  const { websocket, callStore } = useEntitiesContext()

  const handle = (data: IResponseCallResumeConfirmed) => {
    callStore.markResumeConfirmed(data.call_sid)
  }

  useEffect(() => websocket.on(WebsocketEvent.CallResumeConfirmed, handle), [])
}
